import { Button, Col, Form, Mentions, message, Modal, Row } from 'antd';
import moment from 'moment';
import React, { useState } from "react";
import {
    injectIntl
} from "react-intl";
import { useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
// import {
//     actionCancelTransasctionMoney,
//     actionConfrimTransasctionMoney
// } from '../../../redux/transaction/actions';
import {
    Card,
    CardBody,
    CardHeader
} from "../../../_metronic/_partials/controls";
import { formatCoinID, formatMoney, formatMoneyCoin } from '../../lib/common';


const dateFormat = 'YYYY/MM/DD';
const formRef = React.createRef()
function DetailSwapHNG(props) {
    const dispatch = useDispatch();
    const { intl } = props
    const { visibleModal, onCloseModal, recordModal, filterModal } = props
    const [visible, setVisible] = useState(visibleModal)

    const [modalCancel, setModalCancel] = useState(false)
    const [modalConfrim, setModalConfrim] = useState(false)


    const renderType = (key) => {
        switch (key) {
            case "by_order":
                return "Phí Mua Hàng"
            case "deposit":
                return "Nạp Tiền"
            case "swap_gold_money":
                return "Bán Vàng"
            case "swap_money_gold":
                return "Mua Vàng"
            case "withdraw_gold":
                return "Rút Vàng"
            default:
                return ""
        }
    }

    const renderStatus = (status) => {
        switch (status) {
            case 0: {
                return "Chờ duyệt"
            }
            case 1: {
                return "Thành công"
            }
            case 2: {
                return "Hoàn thành"
            }
            case -1: {
                return "Ngừng giao dịch"
            }
            default:
                break;
        }
    }

    const [form] = Form.useForm();
    // const onFinishCancel = async () => {
    //     try {
    //         const { reason } = form.getFieldValue();
    //         let res = await dispatch(actionCancelTransasctionMoney({ dataPush: { transaction_id: recordModal?.transaction_id, reason }, filterModal }))

    //         if (res.code === 200) {
    //             setModalCancel(false)
    //             onCloseModal(false)
    //             setVisible(false)
    //             message.error("Đã hủy giao dịch thành công");
    //         }

    //     } catch (errInfo) {
    //         return message.errInfo
    //     }
    // };
    // const onFinishConfrim = async () => {
    //     try {
    //         const { reason } = form.getFieldValue();
    //         let res = await dispatch(actionConfrimTransasctionMoney({ dataPush: { transaction_id: recordModal?.transaction_id, reason }, filterModal }))
    //         if (res.code === 200) {
    //             setModalConfrim(false)
    //             onCloseModal(false)
    //             setVisible(false)
    //             message.success("Đã duyệt giao dịch thành công");
    //         }
    //     } catch (errInfo) {
    //         return message.errInfo
    //     }
    // };

    const convertType = (value)=>{
        if(value === 'swap_HNG_VNĐ' || value === 'withdrawal'){
            return 'Bán HNG'
        }else{
            return 'Mua HNG'
        }
    }
    const _convertValue = (value) => {
        const strValue = `${value}`;
        const arr = strValue.split(".");
        let decimalPart = arr[1] ? arr[1].slice(0, 5) : "";
        decimalPart = decimalPart.replace(/0+$/, "");
        const result = decimalPart ? `${arr[0]},${decimalPart}` : `${arr[0]}`;
    
        return result;
      };
    console.log(recordModal,'====================');
    return (
        <Modal visible={visibleModal}
            bodyStyle={{ position: "relative" }} onCancel={onCloseModal} style={{ top: 0 }}
            centered={true}
            footer={recordModal?.status === 1 && recordModal?.type === "deposit" ?
                (<div>
                    <Button type="primary" danger onClick={() => setModalCancel(true)}>Hủy</Button>
                    <Button type="primary" onClick={() => setModalConfrim(true)} >Duyệt</Button>
                </div>)
                :
                recordModal?.status === 0 && recordModal?.type === "deposit" ?
                    (<div>
                        {/* <Button type="primary" danger onClick={() => setModalCancel(true)}>Hủy</Button>
                        <Button type="primary" onClick={() => setModalConfrim(true)}>Duyệt</Button> */}
                    </div>)
                    : null
            }
        >
            <Card>
                <CardHeader title={`Trạng thái: ${renderStatus(recordModal?.status)}`} >
                </CardHeader>
                <CardBody>
                    <Col span={24}>
                        <div style={{ fontSize: 18, marginBottom: 12 }} className="customLabel">Thông tin {(renderType(recordModal?.type)).toLowerCase()}</div>
                        <Row style={{ marginBottom: "10px" }}>
                            <Col style={{ marginBottom: "10px" }} span={12}>
                                <lable className="customLabel">Người gửi:</lable>
                                <div>{recordModal?.user?.fullname || "--"}</div>
                                <div>{recordModal?.user?.email || "--"}</div>
                                <div>{recordModal?.user?.mobile || "--"}</div>
                            </Col>
                            <Col style={{ marginBottom: "10px" }} span={12}>
                                <lable className="customLabel">Loại giao dịch:</lable>
                                <div>{convertType(recordModal?.type) || "--"}</div>
                            </Col>
                            <Col style={{ marginBottom: "10px" }} span={12}>
                                <lable className="customLabel">Giá trị nhận:</lable>
                                {recordModal?.type == 'swap_HNG_VNĐ' ? <div>{`${formatCoinID((recordModal?.amount_coin_destination || 0), 1) || "--"}`}</div> : recordModal?.type == 'swap_VNĐ_HNG' ? <div>{`${formatCoinID((recordModal?.amount_coin_destination || 0), 3)}` || "--"}</div> : recordModal?.type == 'deposit' ? <div>{`${formatCoinID((recordModal?.amount_receive_coin_cal || 0), 3)}` || "--"}</div> : <div>{`${_convertValue(recordModal?.amount || 0)} TON` || "--"}</div>}
                            </Col>
                            <Col style={{ marginBottom: "10px" }} span={12}>
                                <lable className="customLabel">Phí chuyển:</lable>
                                {Number(recordModal?.fee || 0) !== 0 ? <div>{formatMoney(recordModal?.fee || 0) || ""}</div> : <div>Miễn phí</div>}
                            </Col>
                        </Row>
                        <Row >
                            <Col style={{ marginBottom: "10px" }} span={12}>
                                <lable className="customLabel">Mã giao dịch:</lable>
                                <div>{recordModal?.type == 'swap_HNG_VNĐ' || recordModal?.type == 'swap_VNĐ_HNG' ? recordModal?.transaction_id : recordModal?.comment}</div>
                            </Col>
                            <Col style={{ marginBottom: "10px" }} span={12}>
                                <lable className="customLabel">Ngày chuyển:</lable>
                                <div>{recordModal?.createdAt ? moment(recordModal?.createdAt).format('DD/MM/YYYY HH:mm:ss') : ""}</div>
                            </Col>
                        </Row>
                    </Col>

                    {/* <Modal visible={modalCancel}
                        closable={() => setModalCancel(false)}
                        onCancel={() => setModalCancel(false)}
                        onOk={onFinishCancel}
                    >
                        <div style={{ fontWeight: 1200, fontSize: 18 }} className="customLabel">Lý do hủy giao dịch</div>
                        <Form form={form} layout="horizontal" >
                            <Form.Item
                                name="reason"
                                labelCol={{ span: 6 }}
                                wrapperCol={{ span: 16, }}
                                rules={[{ required: true, },]}
                            >
                                <Mentions rows={3} placeholder="Nhập lý do hủy giao dịch">
                                </Mentions>
                            </Form.Item>
                        </Form>
                    </Modal>
                    <Modal visible={modalConfrim}
                        closable={() => setModalConfrim(false)}
                        onCancel={() => setModalConfrim(false)}
                        onOk={onFinishConfrim}
                    >
                        <div style={{ fontWeight: 1200, fontSize: 18 }} className="customLabel">Lý do duyệt</div>
                        <Form form={form} layout="horizontal">
                            <Form.Item
                                name="reason"
                                labelCol={{ span: 6 }}
                                wrapperCol={{ span: 16, }}
                                rules={[{ required: true, },]}
                            >
                                <Mentions rows={3} placeholder="Nhập lý duyệt">
                                </Mentions>
                            </Form.Item>
                        </Form>
                    </Modal> */}
                </CardBody>
            </Card>
        </Modal >

    );
}

export default injectIntl(withRouter(DetailSwapHNG));
